/* eslint-disable import/prefer-default-export */
import { useAppSelector } from '../app/hooks'

export const useLiveReportId = () => {
  const reportId = useAppSelector(({ liveReportConfig }) => liveReportConfig?.reportId)
  return reportId
}

export const useLiveReportInfo = () => {
  const reportInfo = useAppSelector(({ liveReportConfig }) => liveReportConfig?.reportInfo)
  return reportInfo
}

export const useLiveReportSuggestedUserList = () =>
  useAppSelector(({ suggestedUserList }) => suggestedUserList)

export const useLiveReportSavingInfo = () => {
  const savingInfo = useAppSelector(({ liveReportConfig }) => liveReportConfig?.savingInfo)
  return savingInfo
}

export const useIsLiveReportReady = () =>
  useAppSelector(
    ({ liveReportConfig, suggestedUserList }) =>
      liveReportConfig?.reportId.status !== 'loading' &&
      liveReportConfig?.reportInfo.status !== 'loading' &&
      suggestedUserList?.status !== 'loading'
  )
